import React from 'react';
import Container from './components/container';
import './App.css';

export default function App() {
  return (
    <div className="App">
      <Container />
    </div>
  );
}
